import { useTheme, isDarkTheme } from 'foundations-theming/utils';
export const useIsDarkMode = () => {
  const theme = useTheme();
  return isDarkTheme(theme);
};